import css from './autoSpeechToggler.module.scss';

import { memo } from 'react';

import useLocalStorageState from 'core/hooks/browser/useLocalStorageState';
import { AUTO_SPEECH, AUTO_SPEECH_DEFAULT } from 'core/options';
import { Icon } from 'core/ui/icons';

const AutoSpeechToggler = () => {
  const [isOn, setIsOn] = useLocalStorageState(
    AUTO_SPEECH,
    AUTO_SPEECH_DEFAULT
  );

  return (
    <div
      className={css.speechToggler}
      data-on={isOn}
      onClick={() => setIsOn(!isOn)}
    >
      <Icon icon="PlaySound" />
    </div>
  );
};

export default memo(AutoSpeechToggler);
